/**
 * envConstants.js
 *
 * Non-secret, environment-aware configuration. Safe to commit.
 *
 * RULE — what belongs here vs pipeline variable groups:
 *   ✅ Here (safe to commit): API base URLs, endpoint suffixes, org/project IDs,
 *      feature flags, client IDs (non-secret identifiers), static paths/scopes.
 *   ❌ Pipeline only (never commit): AES keys, client secrets/assertions,
 *      subscription keys, tokens, passwords, OIDC secret keys.
 */

var ENV = process.env.REACT_APP_ENV || 'dev';

// ─── Per-environment non-secret config ──────────────────────────────────────

var ENV_CONFIG = {
	local: {
		API_BASE_URL: 'https://unlockokr-apim-prod.azure-api.net',
		BLOB_BASE_URL: 'https://unlockokrblobcdndev.azureedge.net',
		API_SUFFIX: '-dev',
		SIGNALR_CONNECTION: 'https://api-dev.unlockokr.com/signalr/notify',
		WHATS_NEW_URL: 'https://admin-dev.unlocku.com/whats-new',
		UBOT_API_SUFFIX: '-dev',
		UBOT_ORGID: '4f508629-e1ff-41c7-8942-ec0907d26d0f',
		UBOT_PROJECTID: '0bd76422-6f10-4125-8871-490c7213c7b0',
		COURSES_API_ENDPOINT: 'https://lms-staging.compunnel.com/webservice/rest/server.php',
		IS_GUIDED_TOUR_SHOW: true,
		AZURE_CLIENT_ID: '7f7df9e5-c075-4883-9294-2d5000f29186',
		AZURE_SCOPE1: 'api://7f7df9e5-c075-4883-9294-2d5000f29186/Users.Read',
	},
	dev: {
		API_BASE_URL: 'https://unlockokr-apim-prod.azure-api.net',
		BLOB_BASE_URL: 'https://unlockokrblobcdndev.azureedge.net',
		API_SUFFIX: '-dev',
		SIGNALR_CONNECTION: 'https://api-dev.unlockokr.com/signalr/notify',
		WHATS_NEW_URL: 'https://admin-dev.unlocku.com/whats-new',
		UBOT_API_SUFFIX: '-dev',
		UBOT_ORGID: '4f508629-e1ff-41c7-8942-ec0907d26d0f',
		UBOT_PROJECTID: '0bd76422-6f10-4125-8871-490c7213c7b0',
		COURSES_API_ENDPOINT: 'https://lms-staging.compunnel.com/webservice/rest/server.php',
		IS_GUIDED_TOUR_SHOW: true,
		AZURE_CLIENT_ID: 'ad2e6351-5e26-46e7-90bc-e449934f43e2',
		AZURE_SCOPE1: 'api://ad2e6351-5e26-46e7-90bc-e449934f43e2/OKRSingletenantScope',
	},
	qa: {
		API_BASE_URL: 'https://unlockokr-apim-prod.azure-api.net',
		BLOB_BASE_URL: 'https://unlockokrblobcdnqa.azureedge.net',
		API_SUFFIX: '-qa',
		SIGNALR_CONNECTION: 'https://api-qa.unlockokr.com/signalr/notify',
		WHATS_NEW_URL: 'https://admin-qa.unlocku.com/whats-new',
		UBOT_API_SUFFIX: '-dev',
		UBOT_ORGID: '4f508629-e1ff-41c7-8942-ec0907d26d0f',
		UBOT_PROJECTID: '0bd76422-6f10-4125-8871-490c7213c7b0',
		COURSES_API_ENDPOINT: 'https://lms-staging.compunnel.com/webservice/rest/server.php',
		IS_GUIDED_TOUR_SHOW: true,
		AZURE_CLIENT_ID: 'd707c99e-7372-4829-8155-525b61b9c5fb',
		AZURE_SCOPE1: 'api://d707c99e-7372-4829-8155-525b61b9c5fb/OKR-QA',
	},
	uat: {
		API_BASE_URL: 'https://unlockokr-apim-prod.azure-api.net',
		BLOB_BASE_URL: 'https://unlockokrcdnuat.azureedge.net',
		API_SUFFIX: '-uat',
		SIGNALR_CONNECTION: 'https://api-uat.unlockokr.com/signalr/notify',
		WHATS_NEW_URL: 'https://admin-uat.unlocku.com/whats-new',
		UBOT_API_SUFFIX: '-dev',
		UBOT_ORGID: '4f508629-e1ff-41c7-8942-ec0907d26d0f',
		UBOT_PROJECTID: '0bd76422-6f10-4125-8871-490c7213c7b0',
		COURSES_API_ENDPOINT: 'https://lms-staging.compunnel.com/webservice/rest/server.php',
		IS_GUIDED_TOUR_SHOW: true,
		AZURE_CLIENT_ID: '104c9960-69ce-4a95-b421-9c980135f62f',
		AZURE_SCOPE1: 'api://104c9960-69ce-4a95-b421-9c980135f62f/OKR-UAT',
	},
	trial: {
		API_BASE_URL: 'https://unlockokr-apim-trial.azure-api.net',
		BLOB_BASE_URL: 'https://unlockokrblobcdntrial.azureedge.net',
		API_SUFFIX: '-trial',
		SIGNALR_CONNECTION: 'https://api-trial.unlockokr.com/signalr/notify',
		WHATS_NEW_URL: 'https://admin-trial.unlocku.com/whats-new',
		UBOT_API_SUFFIX: '-dev',
		UBOT_ORGID: '4f508629-e1ff-41c7-8942-ec0907d26d0f',
		UBOT_PROJECTID: '0bd76422-6f10-4125-8871-490c7213c7b0',
		COURSES_API_ENDPOINT: '',
		IS_GUIDED_TOUR_SHOW: false,
		AZURE_CLIENT_ID: 'aa41a90b-1e1d-41a9-854e-aa425fa31d3a',
		AZURE_SCOPE1: 'api://ca2caa9d-b491-4b46-ae6f-a2f55538537d/OKRAuthorizationApptrial',
		// Trial uses a full absolute URL for UnlockU (not just the path)
		UNLOCK_U_SERVER_OVERRIDE: 'https://unlock-u.unlocklearn.com/webservice/rest/server.php',
	},
	production: {
		API_BASE_URL: 'https://unlockokr-apim-prod.azure-api.net',
		BLOB_BASE_URL: 'https://unlockokrblobcdnprod.azureedge.net',
		API_SUFFIX: '',
		SIGNALR_CONNECTION: 'https://api-prod.unlockokr.com/signalr/notify',
		WHATS_NEW_URL: 'https://admin.unlocku.com/whats-new',
		UBOT_API_SUFFIX: '',
		UBOT_ORGID: '3147798d-43b1-4937-a2f5-3b64d8ec70df',
		UBOT_PROJECTID: 'fe3c7c3e-f15c-465c-80cd-55f80f2a9253',
		COURSES_API_ENDPOINT: '',
		IS_GUIDED_TOUR_SHOW: true,
		AZURE_CLIENT_ID: 'ca2caa9d-b491-4b46-ae6f-a2f55538537d',
		AZURE_SCOPE1: 'api://ca2caa9d-b491-4b46-ae6f-a2f55538537d/OKRAuthorizationAppProd',
	},
};

export var envConfig = ENV_CONFIG[ENV] || ENV_CONFIG.dev;

// ─── Truly static values (same across every environment) ─────────────────────

/** Shared Azure AD tenant ID */
export var AZURE_TENANT_ID = 'e648628f-f65c-40cc-8a28-c601daf26a89';

/** Graph API scope — identical across all environments */
export var AZURE_SCOPE = 'https://graph.microsoft.com/.default';

/** Full MSAL authority URL — same tenant for every env */
export var AZURE_AUTHORITY = 'https://login.microsoftonline.com/e648628f-f65c-40cc-8a28-c601daf26a89';

/** OIDC SSO scope — same across all environments */
export var SSO_SCOPE = 'openid profile email';

/** GA tracking ID — same across all environments */
export var GOOGLE_ANALYTICS_ID = 'UA-213649459-1';

/** Relative path for UnlockU REST server (appended to tenant learnUrl) */
export var UNLOCK_U_SERVER_PATH = 'webservice/rest/server.php';

/** SSO login path for LearningU (appended to tenant learnUrl) */
export var LEARNINGU_SSO_PATH = 'sso/login.php';

/** Full UnlockU server URL for infoprolearning domain */
export var UNLOCK_U_SERVER_INFO = 'https://infoprolearning.unlocklearn.com/webservice/rest/server.php';

/** Full LearningU SSO URL for infoprolearning domain */
export var LEARNINGU_INFO = 'https://infoprolearning.unlocklearn.com/sso/login.php';

/** APIM base URL used by the AI Bot (always prod APIM) */
export var AI_BOT_APIM_BASE_URL = 'https://unlockokr-apim-prod.azure-api.net';

/** Reports service base URL */
export var REPORTS_BASE_URL = 'https://okr-dev-reporting.compunnel.com/api/';

/** MS Graph me endpoint */
export var GRAPH_ME_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

// ─── OIDC per-tenant client IDs and authorities (non-secret identifiers) ──────

export var OIDC_TENANTS = {
	localhost: {
		client_id: '7f7df9e5-c075-4883-9294-2d5000f29186',
		authority: 'https://login.microsoftonline.com/e648628f-f65c-40cc-8a28-c601daf26a89',
	},
	dev: {
		client_id: 'ad2e6351-5e26-46e7-90bc-e449934f43e2',
		authority: 'https://login.microsoftonline.com/e648628f-f65c-40cc-8a28-c601daf26a89',
	},
	qa: {
		client_id: 'd707c99e-7372-4829-8155-525b61b9c5fb',
		authority: 'https://login.microsoftonline.com/e648628f-f65c-40cc-8a28-c601daf26a89',
	},
	uat: {
		client_id: '104c9960-69ce-4a95-b421-9c980135f62f',
		authority: 'https://login.microsoftonline.com/e648628f-f65c-40cc-8a28-c601daf26a89',
	},
	infoprolearning: {
		client_id: 'ca2caa9d-b491-4b46-ae6f-a2f55538537d',
		authority: 'https://login.microsoftonline.com/e648628f-f65c-40cc-8a28-c601daf26a89',
	},
	// Google OAuth tenants — client_id is non-secret; client_secret stays in pipeline
	googletest: {
		client_id: '889960029042-1e7mkcv2d7qi94kpcibm8pqonns0svdp.apps.googleusercontent.com',
		authority: 'https://accounts.google.com',
	},
	innovant: {
		client_id: '140108286192-1r65itkfhpa1f8h6o1q0r44v0c95cms4.apps.googleusercontent.com',
		authority: 'https://accounts.google.com',
	},
	compunnel: {
		client_id: '3aa42f7c-df33-4064-a9d2-15dfd0e2cdcf',
		authority: 'https://login.microsoftonline.com/edbeb3be-d5a3-4095-a227-56c88813e6f7',
	},
};
